import { CheckboxesWrapper } from "./field_wrappers/checkboxes_wrapper";
import InlineCalendarWrapper from "./field_wrappers/inline_calendar_wrapper";
import InlineRangeCalendarWrapper from "./field_wrappers/inline_range_calendar_wrapper";
import { InputFieldSetWrapper } from "./field_wrappers/input_field_set_wrapper";
import { IntegerWrapper } from "./field_wrappers/integer_wrapper";
import { SelectWrapper } from "./field_wrappers/select_wrapper";
import { ToggleWrapper } from "./field_wrappers/toggle_wrapper";

export const propertyTypeToComponentMap = {
  "string": InputFieldSetWrapper,
  "text": InputFieldSetWrapper,
  "url": InputFieldSetWrapper,
  "link": InputFieldSetWrapper,
  "date": InlineCalendarWrapper,
  "date-time": InlineCalendarWrapper,
  "date-range": InlineRangeCalendarWrapper,
  "select": SelectWrapper,
  "integer": IntegerWrapper,
  "toggle": ToggleWrapper,
  "checkboxes": CheckboxesWrapper
};
